var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-container"},[_c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require("@/assets/header/logo.svg"),"alt":""}}),_c('div',{staticClass:"nav-list"},[_vm._l((_vm.nav_list),function(item,index){return [_c('router-link',{key:index,attrs:{"to":item.link}},[_vm._v(_vm._s(item.name))])]})],2),_c('side-menu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }